import { Metric, BarList, Flex, Text } from "@tremor/react";
import ExpandableChartCard from "../../../../shared/charts/ExpandableChartCard";

/**
 * codex.md — NPS. Inline shows top 5 rated clients; expand reveals
 * the full list. Metric + BarList — no traditional chart library
 * consumer.
 *
 * wbrData: { avgNps, npsCount, totalClients, clients: [{ name, service, nps }] }
 */
const INLINE_LIMIT = 5;

export default function NpsChart({ wbrData, canSee, target }) {
  if (!canSee) return null;
  const rows = (wbrData?.clients || [])
    .filter((c) => typeof c.nps === "number")
    .map((c) => ({ name: c.name, value: c.nps }))
    .sort((a, b) => b.value - a.value);
  const total = rows.length;
  return (
    <ExpandableChartCard
      title="NPS — Client Satisfaction"
      subtitle={wbrData
        ? `${wbrData.npsCount}/${wbrData.totalClients} rated · Avg ${wbrData.avgNps ?? "—"}/5 · Target ${target}`
        : "Loading…"}
      renderChart={({ expanded }) => {
        const visible = expanded ? rows : rows.slice(0, INLINE_LIMIT);
        const hiddenCount = total - visible.length;
        return (
          <div>
            <Flex justifyContent="start" alignItems="baseline" className="space-x-3">
              <Metric>{wbrData?.avgNps ?? "—"}</Metric>
              <Text>/ 5</Text>
            </Flex>
            {visible.length > 0 && (
              <BarList
                data={visible}
                className="mt-4"
                color="emerald"
                valueFormatter={(v) => `${v}/5`}
              />
            )}
            {!expanded && hiddenCount > 0 && (
              <div style={{ marginTop: 10, fontSize: 11, color: "#6889b4" }}>
                + {hiddenCount} more — click ⛶ Expand to see all.
              </div>
            )}
          </div>
        );
      }}
    />
  );
}
